define(
({
  "alert": "Alerte",
  "okay": "OK"
})
);
